/**
 * Nos ayuda a generar colores aleatoreos de una lista
 */
let actual_color = '0';
const generateRandomColors = () => {
    const colors = [
        '#1abc9c',
        '#2ecc71',
        '#3498db',
        '#9b59b6',
        '#f1c40f',
        '#16a085',
        '#27ae60',
        '#2980b9',
        '#8e44ad',
        '#f1c40f',
        '#e67e22',
        '#e74c3c',
        '#ecf0f1',
        '#95a5a6',
        '#f39c12',
        '#d35400',
        '#c0392b',
        '#bdc3c7'
    ];
    let final_color = '0';
    while(final_color === actual_color) {
        final_color = colors[Phaser.Math.Between(0, colors.length - 1)]
    }
    return final_color;
}

export default generateRandomColors;